<template>
  <el-container class="grid-layout">
    <!-- Page Header -->
    <el-header class="title" height="max-content">
      <h5 class="text-sc">
        <b>{{ title }}</b>
      </h5>
      <el-button
        type="text"
        class="back-button"
        @click="goto('LineNotifyNotice')"
      >
        กลับ
      </el-button>
    </el-header>

    <el-main class="content grid-layout">
      <div
        :style="{
          'text-align': 'right',
        }"
      >
        <el-button
          type="danger"
          @click="
            alertModal(
              `ลบข้อมูล`,
              `ลบข้อมูลของผู้ใช้ทั้งหมดของ ${fullName}`,
              () => removeUser(user.ruejai_id),
            )
          "
        >
          ลบผู้ใช้งาน
        </el-button>
      </div>

      <div class="grid-layout detail-item">
        <div>
          <p>
            <b>ชื่อ-นามสกุล</b>
          </p>
          <p class="text-secondary">
            {{ user.first_name }} {{ user.last_name }}
          </p>
        </div>
        <div>
          <p>
            <b>อีเมล์</b>
          </p>
          <p class="text-secondary">
            {{ user.email }}
          </p>
        </div>
        <div>
          <p>
            <b>ตำแหน่ง</b>
          </p>
          <p class="text-secondary">
            {{ user.role_name }}
          </p>
        </div>
        <div>
          <p class="text-line">
            <b>LINE UID</b>
          </p>
          <p class="text-secondary">
            {{ user.line_id }}
          </p>
        </div>
      </div>

      <div>
        <b> โครงการที่เกี่ยวข้อง </b>
      </div>

      <div
        :style="{
          'text-align': 'right',
        }"
      >
        <el-button
          :disabled="allNotice"
          type="primary"
          @click="dialog.open = true"
        >
          เพิ่มโครงการ
        </el-button>
      </div>

      <!-- Project Empty -->
      <el-empty
        v-if="user.notices.length < 1"
        :image-size="200"
        description="
          ไม่พบข้อมูล
        "
      />

      <!-- Project List -->
      <div class="grid-layout list-item">
        <div
          v-for="(item, i) in noticeItems"
          :key="i"
          class="grid-layout item el-card"
        >
          <el-avatar :size="80" shape="square">
            <b>
              {{ item.code }}
            </b>
          </el-avatar>
          <div class="content">
            <b class="text-title">
              {{ item.name }}
            </b>
            <p class="text-secondary text-ellipsis">
              {{ item.location }}
            </p>
          </div>
          <div v-if="item.id">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="
                alertModal(`ลบข้อมูล`, `ลบโครงการ ${item.name}`, () =>
                  removeNotice(item.id),
                )
              "
            >
            </el-button>
          </div>
        </div>

        <!-- Project Paging -->
        <el-pagination
          v-if="paging.total >= paging.size"
          :current-page.sync="paging.current"
          :page-size="paging.size"
          :total="paging.total"
          class="text-center"
          layout="
            prev, pager, next
          "
        />
      </div>
    </el-main>

    <!-- Dialog -->
    <el-dialog
      :visible.sync="dialog.open"
      :close-on-click-modal="false"
      :show-close="false"
      title="ค้นหาโครงการ"
      top="0"
    >
      <!-- Project Selector -->
      <SelectProject
        :search="project.search"
        :page="project.page"
        :disabled-items="user.notices.map(({ project_id }) => project_id)"
        :selected="project.items.map(({ id }) => id)"
        @select="(data) => select(data)"
        @unselect="(id) => unselect(id)"
        @page-change="
          ({ text, page }) => {
            project.search = text
            project.page = page
          }
        "
      >
      </SelectProject>

      <!-- Dialog Footer -->
      <div slot="footer" class="text-center">
        <el-button
          :disabled="projectLength == 0"
          type="primary"
          @click="
            () => {
              dialog.open = false
              addNotice()
            }
          "
        >
          เพ่ิม {{ projectLength > 0 ? projectLength : "" }}
        </el-button>
        <el-button
          type="danger"
          @click="
            () => {
              dialog.open = false
              project.items = []
            }
          "
        >
          ยกเลิก
        </el-button>
      </div>
    </el-dialog>

    <!-- Alert -->
    <el-dialog
      :title="alert.title"
      :visible.sync="alert.open"
      width="40%"
      top="0"
    >
      <span>
        {{ alert.message }}
      </span>

      <div slot="footer">
        <el-button type="info" @click="alert.open = false"> ปิด </el-button>
        <el-button
          v-if="typeof alert.handler == 'function'"
          class="sc-color"
          type="primary"
          @click="
            () => {
              alert.handler()
              alert.open = false
            }
          "
        >
          ตกลง
        </el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
// Services
import { useCases } from "../LineNotifyService"

// Components
import SelectProject from "../components/LineNotifySelectProject"

export default {
  name: "LineNotifyUser",
  components: {
    SelectProject,
  },
  data() {
    return {
      title: "ผู้ใช้งาน",
      user: {
        first_name: "",
        last_name: "",
        email: "",
        role_name: "",
        notices: [],
      },
      project: {
        search: "",
        page: 1,
        items: [],
      },
      dialog: {
        open: false,
      },
      alert: {
        open: false,
        title: "",
        message: "",
        handler: null,
      },
      paging: {
        current: 1,
        total: 0,
        size: 5,
      },
    }
  },
  computed: {
    fullName({ user }) {
      return `${user.first_name} ${user.last_name}`
    },
    roleName({ user }) {
      return `${user.role_name || ""}`.toUpperCase()
    },
    start({ paging }) {
      return paging.size * paging.current - paging.size
    },
    end({ start, paging }) {
      return start + paging.size
    },
    allNotice() {
      return ["ADMIN", "CC", "HC", "CRM"].some((e) => e === this.roleName)
    },
    noticeItems({ start, end }) {
      return [...this.user.notices]
        .sort((a, b) => b.id - a.id)
        .slice(start, end)
    },
    projectLength({ project }) {
      return project.items.length
    },
  },
  watch: {
    roleName() {
      // Validate Role
      if (this.allNotice) {
        // All Notification for Admin
        this.user.notices = []
        this.user.notices.push({
          code: "ALL",
          name: "ทุกโครงการ",
          location: "รับการแจ้งเตือนทุกโครงการ",
        })
      }
    },
    "user.notices": function userNoticesWatcher(notice) {
      // Total Notice Count
      this.paging.total = notice.length
    },
    "alert.open": function alertOpenWatcher(open) {
      // Reset Alert
      if (!open) {
        this.alert.title = ""
        this.alert.message = ""
        this.alert.handler = null
      }
    },
  },
  created() {
    // Query Parameters
    const { user } = this.$route.params

    // Routing to Notice Page
    if (!user) {
      this.goto("LineNotifyNotice")
    } else {
      // User ID
      this.user = user
    }
  },
  methods: {
    goto(name) {
      this.$router.push({ name })
    },
    select(data) {
      // Validate Existing Data
      const exist = this.project.items.some(({ id }) => id === data.id)

      // Add Project
      if (!exist) this.project.items.push(data)
    },
    unselect(id) {
      // Remove Project List
      this.project.items = this.project.items.filter((e) => e.id !== id)
    },
    async addNotice() {
      // Set Parameters
      const { ruejai_id: userId } = this.user
      let project = this.project.items.map(({ id: projectId }) => projectId)

      // Validate Required Data
      // Add Notices
      const { code, message, data } = await useCases.addNotice(userId, project)

      // Remove Success
      if (code === 20000) {
        // Map Project
        project = this.project.items.reduce(
          (prev, curr) => ({
            ...prev,
            [curr.id]: curr,
          }),
          {},
        )

        // Add Inserted Data
        /* eslint-disable camelcase -- API response */
        this.user.notices.push(
          ...data.map(({ id: noticeId, project_id }) => ({
            ...project[project_id],
            id: noticeId,
            project_id,
          })),
        )
        /* eslint-enable camelcase */

        // Clear Added Project
        this.project.items = []
      } else {
        // Alert Error
        this.alert = {
          open: true,
          title: "เกิดข้อผิดพลาด",
          message,
        }
      }
    },
    async removeUser(id) {
      // Remove Notice
      const { code, message } = await useCases.removeUser(id)

      // Remove Success
      if (code === 20000) {
        // Default Page
        this.goto("LineNotifyNotice")
      } else {
        // Error Alert
        this.alert = {
          open: true,
          title: "เกิดข้อผิดพลาด",
          message,
        }
      }
    },
    alertModal(title, message, handler) {
      // Alert Status
      this.alert = {
        open: true,
        title,
        message,
        handler,
      }
    },
    async removeNotice(id) {
      // Notice List
      const { notices } = this.user

      // Remove Notice
      const { code, message } = await useCases.removeNotice(id)

      // Remove Success
      if (code === 20000) {
        // Update Notices
        this.user.notices = notices.filter((e) => e.id !== id)
      } else {
        // Alert Error
        this.alert = {
          open: true,
          title: "เกิดข้อผิดพลาด",
          message,
        }
      }
    },
  },
}
</script>

<style scoped>
@import url("../LineNotify.css");

.text-line {
  color: #02c153;
}

.detail-item {
  grid-template-columns: repeat(2, 1fr);
}

@media screen and (max-width: 768px) {
  .detail-item,
  .list-item {
    grid-template-columns: 100%;
  }
}
</style>
